import { CarFleetViewRecord } from '@navio/nsdk';
import { NoddiBadge } from 'noddi-ui-web';
import { BadgeColumnContainer } from './BadgeColumnContainer';
import { BookingInFleetTable } from './BookingInFleetTable';

// Per-car booking slice as exposed by list endpoints (fleet view,
// storage inventory). Derived from CarFleetViewRecord so this stays
// in sync with the backend BookingForCarRecord shape without naming
// it directly — the nsdk type name has churned.
type BookingForCar = NonNullable<CarFleetViewRecord['upcomingBooking']>;

type Props = {
  booking: BookingForCar | null | undefined;
  cancelledLabel?: string;
  noneLabel?: string;
};

export const UpcomingBookingCell = ({ booking, cancelledLabel = 'Cancelled', noneLabel = 'None' }: Props) => {
  if (!booking) {
    return (
      <BadgeColumnContainer>
        <NoddiBadge variant='outline'>{noneLabel}</NoddiBadge>
      </BadgeColumnContainer>
    );
  }
  return (
    <BookingInFleetTable
      date={booking.date}
      variant='upcoming'
      deliveryWindowStartsAt={booking.deliveryWindowStartsAt}
      deliveryWindowEndsAt={booking.deliveryWindowEndsAt}
      salesItems={booking.salesItems}
      cancelledAt={booking.cancelledAt}
      cancelledLabel={cancelledLabel}
    />
  );
};
